const lineMatch =
  /\(([0-9A-Za-z]+,[0-9A-Za-z]+)\) (..) (?:\((.*)\)|\[(.*)\]|((?:.|\n)*?)) *# *(.*)/; // correctly handle newlines in value

export default (line) => {
  /* eslint no-cond-assign: 0 */
  let m;
  let result;
  if ((m = lineMatch.exec(line)) !== null) {
    // The result can be accessed through the `m`-variable.
    result = {
      tag: m[1].toLowerCase(),
      vr: m[2],
      value: m[3] || m[4] || m[5],
      description: m[6]
    };
    if (result.value && (result.value === "no value available" || result.vr === "SQ")) {
      result.value = "";
    } else if (result.vr === "na") {
      result.value = "-";
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/mainInterface/js/dicom/dicom-header-line.js